import initializeNewLikeNotificationFilter from './initialization/initializeNewLikeNotificationFilter';
import initializeNewMailNotificationFilter from './initialization/initializeNewMailNotificationFilter';
import initializeProtocolHandlers from './initializeProtocolHandlers';
import { initializeServiceWorker } from 'owa-serviceworker-cache';
import setupMailModuleCommonPostRender from './setupMailModuleCommonPostRender';
import { lazyInitializeActivityFeed } from 'owa-activity-feed';
import { isFeatureEnabled } from 'owa-feature-flags';
import 'owa-getstarted-bootstrap';
import { initializeGetStartedTasksLazy } from 'owa-getstarted';
import { initializeBindStatusLazy } from 'owa-linkedin';
import { lazyLoadSenders } from 'owa-mail-amp-store';
import { lazyGetMailModuleDiagnostics } from 'owa-mail-diagnostics';
import { subscribeToHierarchyNotification } from 'owa-mail-folder-orchestration';
import { lazyInitializePostIrisService } from 'owa-mail-iris';
import 'owa-mail-list-selection-actions-v2/lib/lazyIndex';
import { registerTriagePatternsOrchestrators } from 'owa-mail-triage-patterns';
import connectedAccountsNotificationOperation from 'owa-service/lib/operation/connectedAccountsNotificationOperation';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyInitializeSpotlight } from 'owa-mail-spotlight';
import { lazyInitializePersonalizationSuggestions } from 'owa-personalization';
import { initializeWhatsNewCardsLazy } from 'owa-whats-new';
import { lazyLoadWorkloadScenarioSettings } from 'owa-workload-scenario-settings';
import {
    lazyfindBulkActionItemAction,
    lazySubscribeToBulkActionNotification,
} from 'owa-bulk-action-store';
import {
    shouldOwaInitializeSkype,
    lazyBeginSkypeInitialization,
    lazyCreateOnSwcReadyEvent,
} from 'owa-skype';
import {
    isWebPushNotificationSupported,
    lazybootStrapWebPushService,
} from 'owa-webpush-notifications';
import { lazyGovern, lazyEnableGovernReport } from 'owa-shared-post-boot';
import { lazyGetAccountInformation } from 'owa-storage-store';

export default function setupMailModulePostRender() {
    // tasks in here are governed individually
    setupMailModuleCommonPostRender(true);

    if (isFeatureEnabled('fwk-mailtoProtocolHandler')) {
        initializeProtocolHandlers();
    }
    if (isFeatureEnabled('tri-triagePattern')) {
        registerTriagePatternsOrchestrators();
    }

    lazyGovern
        .importAndExecute(
            {
                // Initialize the singleton diagnostics store to register the diagnostics listeners
                condition: isFeatureEnabled('fwk-devTools'),
                task: () => lazyGetMailModuleDiagnostics.importAndExecute(),
            },
            initNotifications,
            () => lazyLoadWorkloadScenarioSettings.importAndExecute(),
            {
                condition: isConsumer(),
                task: () => lazyLoadSenders.importAndExecute(),
            },
            () => lazyfindBulkActionItemAction.importAndExecute(),
            () => lazySubscribeToBulkActionNotification.importAndExecute(),
            {
                condition: shouldOwaInitializeSkype(),
                task: () => lazyBeginSkypeInitialization.importAndExecute(),
            },
            {
                condition: isFeatureEnabled('tri-spotlight'),
                task: () => lazyInitializeSpotlight.importAndExecute(),
                idle: true,
            },
            // Even if OWA is not responsbile for initializing Skype,
            // Still need listen to SWC ready events and try to intitialize notification settings
            () => lazyCreateOnSwcReadyEvent.importAndExecute(),
            {
                task: () => initializeServiceWorker(window, 'mail'),
                idle: true,
            },
            {
                task: () => initializeGetStartedTasksLazy.importAndExecute(),
                idle: true,
            },
            {
                condition: isFeatureEnabled('mc-personalization'),
                task: () => {
                    lazyInitializePersonalizationSuggestions.importAndExecute();
                },
                idle: true,
            },
            {
                task: () => initializeWhatsNewCardsLazy.importAndExecute(),
                idle: true,
            },
            {
                condition: isFeatureEnabled('rp-linkedInViewProfile'),
                task: () => initializeBindStatusLazy.importAndExecute(),
                idle: true,
            },
            {
                task: () => lazyInitializeActivityFeed.importAndExecute(),
                idle: true,
            },
            {
                condition: isFeatureEnabled('auth-realtimeEmail') && isConsumer(),
                task: () => lazyInitializePostIrisService.importAndExecute(),
                idle: true,
            },
            {
                condition: isWebPushNotificationSupported(window),
                task: () => lazybootStrapWebPushService.importAndExecute(window),
                idle: true,
            },
            {
                condition: isFeatureEnabled('tri-mailboxCleanup'),
                task: () => lazyGetAccountInformation.importAndExecute(),
                idle: true,
            }
        )
        .then(() => {
            // enable reporting after we've queued everything
            lazyEnableGovernReport.importAndExecute();
        });
}

function initNotifications() {
    subscribeToHierarchyNotification();
    initializeNewMailNotificationFilter();
    initializeNewLikeNotificationFilter();

    // this will try the notifications to sync now
    connectedAccountsNotificationOperation({ isOWALogon: true });
}
